<template>
  <div class="page">
    <div class="count-down">
      <span @click="skip">跳过{{countDown}}S</span>
    </div>
    <section class="result-box">
      <vue-lottie class="lottie-animation" key="wait" v-if="status==='wait'" :options="wait"></vue-lottie>
      <vue-lottie class="lottie-animation" key="fail"  v-if="status==='fail'" :options="fail"></vue-lottie>
      <vue-lottie class="lottie-animation" key="success"  v-if="status==='success'" :options="success"></vue-lottie>
    </section>
    <div class="success-title">
      <template v-if="status==='wait'" >授权中</template>
      <template v-if="status==='fail'" >授权失败</template>
      <template v-if="status==='success'">您已成功绑定微信账号！</template>
      
    </div>
    <div class="success-tips">立即关注天美贷公众号获一手福利活动资讯</div>
    <img src="./images/icon_arrow_down.png" class="arrow-down">
    <div class="split">
      <div class="line"></div>
      天美贷微信关注公众号指南
      <div class="line"></div>
    </div>
    <div class="code-box">
      <div class="code-img">
        <img src="./images/img_QR@2x.png">
        <p class="code-text">天美贷公众号</p>
      </div>
      <div class="code-right">
        <div class="right-box right-download" @click="handleDownload">
          <p class="right-p1">点击下载二维码至相册</p>
          <p class="right-p2">微信扫一扫识别关注公众号</p>
        </div>
        <div class="right-box right-copy" @click="copy">
          <p class="right-p1">点击复制微信号   ct_tmd</p>
          <p class="right-p2">微信搜索关注公众号</p>
        </div>
      </div>
    </div>
    <template v-if="status==='fail'">
      <nd-button @click="toBind" >重新绑定</nd-button>
      <p class="bind-bottom-tips" @click="skip">稍后通过「我的-账户与安全」进行绑定</p>
    </template>
    <nd-button @click="skip" v-else>进入天美贷</nd-button>
  </div>
</template>

<script>
import { copyToClipbord } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import waitData from '@/assets/json/wait.json'
import failData from '@/assets/json/fail.json'
import successData from '@/assets/json/success.json'
import VueLottie from 'vue-lottie'
import { mapActions } from 'vuex'
import { Base64 } from 'js-base64'
import axios from 'axios'
import bind from '@/assets/bindWechat.js'
export default {
  name: 'wechat_binded',
  components: {
    VueLottie
  },
  mixins: [bind],
  async mounted () {
    if (this.getParams().code) {
      this.bind()
    } else {
      this.status = 'fail'
    }
    this.$bus.$emit('ready')
  },
  data () {
    return {
      waitData,
      failData,
      successData,
      timer: null, 
      countDown: 5,
      status: 'wait',
      appId: '',
      appsecret: '',
      openid: '',
      wait: { animationData: waitData },
      fail: { animationData: failData, loop: false },
      success: { animationData: successData, loop: false }
    }
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timer)
    next()
  },
  methods: {
    ...mapActions('wxBind', ['getAppInfoX', 'binding']),

    async getAppInfo () {
      const { success, data } = await this.getAppInfoX()
      if (success) {
        const { uid, openUid } = data
        this.appId = Base64.decode(uid)  
        this.appsecret = Base64.decode(openUid)  
      }
    },
    // 去微信拿token - 暂时不走此流程
    async getToken () {
      const res = await axios.get('/weChat/sns/oauth2/access_token', {
        params: {
          appid: this.appId,
          secret: this.appsecret,
          code: this.$route.query.code,
          grant_type: 'authorization_code'
        }
      })
      if (res.code === 200) {
        this.openid = res.data.openid
        this.bind()
      } else {
        this.status = 'fail'
      }
    },
    async bind () {
      const { success, data } = await this.binding({
        code: this.getParams().code
      })
      if (success) {
        if (data.status === 'SUCCESS') {
          this.status = 'success'
        } else {
          this.status = 'fail'
        }
        if (data.status === 'USER_BEEN_BIND') {
          this.$message('该微信已绑定其他账号')
        }
        this.countDownAction()
      }
    },
    skip () {
      this.$router.replace('/')
    },
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },
    handleDownload () {
      this.downloadImage('http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096', 'qrcode')
    },
    async downloadImage (imgsrc, name) {
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else {
        this.$message('请长按左侧二维码保存')
      }
    },
    countDownAction () {
      console.log('begin count down')
      this.timer = setInterval(() => {
        if (this.countDown <= 1) {
          clearInterval(this.timer)
          this.skip()
        } else {
          this.countDown--
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #f7f7f7;
  padding: 0 40px;
  text-align: center;
  .bind-bottom-tips {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 40px;
    }
  .result-box {
    width:180px ;
    height:180px ;
    margin: auto;
  }
  .success-icon {
    margin-top: 52px;
    width: 150px;
    height: 150px;
  }
  .success-title {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 59px;
    margin-top: 18px;
  }
  .success-tips {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-top: 4px;
  }
  .arrow-down {
    width: 32px;
    height: 32px;
    margin-top: 28px;
  }
  .split {
    margin-top: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .line {
        width: 139px;
        height: 1px;
        background: #CCCCCC;
    }
  }
  .count-down {
    padding-top: 83px;
    text-align: end;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    span {
      border-bottom: 1px solid #666;
    }
  }
  .code-box{
    margin-top: 20px;
    background-color: #fff;
    border-radius: 30px;
    padding: 40px 30px;
    display: flex;
    justify-content: space-between;
    color: #333333;
    .code-img{
      width: 160px;
      background-color: #F7F7F7;
      border-radius: 8px;
      padding: 10px;
      text-align: center;
      img{
        width: 140px;
        height: 140px;
      }
      .code-text{
        font-size: 20px;
        line-height: 28px;
        margin-top: 4px;
      }
    }
    .code-right{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 433px;
      .right-box{
        background-color: #F7F7F7;
        background-position: calc(100% - 20px) center;
        background-size: 30px;
        background-repeat: no-repeat;
        padding: 10px 30px;
        border-radius: 8px;
        .right-p1{
          font-size: 26px;
          font-weight: 500;
          line-height: 37px;
        }
        .right-p2{
          font-size: 20px;
          color: #9C9C9C;
          line-height: 28px;
        }
        &.right-download{
          background-image: url(./images/icon_download@2x.png);
        }
        &.right-copy{
          background-image: url(./images/icon_copy@2x.png);
        }
      }
    }
  }
  .nd-button {
    width: 590px;
    height: 94px;
    margin: 30px auto;
  }
}
</style>